import React, { useState, useEffect, useRef } from "react";
import { useNavigate } from "react-router-dom";
import Button from "@mui/material/Button";
import Card from "@mui/material/Card";
import CardContent from "@mui/material/CardContent";
import Typography from "@mui/material/Typography";
import IconButton from "@mui/material/IconButton";
import DeleteIcon from "@mui/icons-material/Delete";
import AddCardIcon from "@mui/icons-material/AddCard";
import PaymentIcon from "@mui/icons-material/Payment";
import { Player } from "@lottiefiles/react-lottie-player";
import Animacion_AgregarTarjetaCreditoDebito from "../../imagenes/Viaje/AgregarTarjetaCreditoDebito.json";
import Animacion_NoTienesViajesPendientes_Pasajero from "../../imagenes/Viaje/NoTienesViajePendiente1.json";
import Animacion_NoTienesViajesPendientes_Conductor from "../../imagenes/Viaje/NoTieneViajesPendientes.json";
import Animacion_ViajePendiente_Pasajero from "../../imagenes/Viaje/ViajePendiente.json";
import Animacion_HemosEncontradoUnConductor_Pasajero from "../../imagenes/Viaje/IconoEsperandoAceptacionDeImporte.json";
import Animacion_EnCamino_Conductor from "../../imagenes/Viaje/EnCamino.json";
import Animacion_EsperandoVehiculo_Conductor from "../../imagenes/Viaje/EsperandoVehiculo.json";
import Animacion_EnCurso_Conductor from "../../imagenes/Viaje/EnCurso.json";
import Animacion_EnCurso_Pasajero from "../../imagenes/Viaje/EnCurso.json";
import Animacion_Valorar_Pasajero from "../../imagenes/Viaje/Valorar2.json";
import {
  Label,
  Icon,
  Rating,
  Message,
  MessageContent,
  MessageHeader,
} from "semantic-ui-react";
import Swal from "sweetalert2";
import { estiloColores } from "../../estilos/colores";
import { apiViaje } from "../../api/viaje";
import { apiMobbex } from "../../api/mobbex";
import { apiUsuario } from "../../api/usuario";
import IconoVerEnGoogleMaps from "@mui/icons-material/Route";
import ActualizarIcon from "@mui/icons-material/Refresh";
import { estiloBotones } from "../../estilos";
import { apiSubastador } from "../../api/subastador";
import "../../scss/index.scss";
import { MapContainer, TileLayer } from "react-leaflet";
import "leaflet/dist/leaflet.css";
import { Marker as LeafletMarker, icon } from "leaflet";
import iconRetinaUrl from "leaflet/dist/images/marker-icon-2x.png";
import iconUrl from "leaflet/dist/images/marker-icon.png";
import IconoLevantarPasajero from "@mui/icons-material/PersonPinCircle";
import IconoAvisarAPasajero from "@mui/icons-material/NotificationsActive";
import IconoFinalizarViaje from "@mui/icons-material/CheckCircleOutline";
import shadowUrl from "leaflet/dist/images/marker-shadow.png";
import * as L from "leaflet";
import "leaflet-routing-machine";
import "leaflet-routing-machine/dist/leaflet-routing-machine.css";
import { ENTORNO } from "../../utils/constantes";
import {
  no_tienes_viajes_pendientes,
  solicita_un_viaje_en_cualquier_momento_en_cualquier_lugar,
  esperando_asignacion_de_viaje,
  vas_a_cancelar_el_viaje_seleccionado,
  el_viaje_no_podra_recuperarse_posterior_a_esta_accion,
  si,
  no,
  cancelar,
  viaje_cancelado_con_exito,
  pendiente_de_asignar_conductor,
  tienes_un_viaje_con_destino_a,
  estamos_buscando_un_conductor_cercano_para_ti,
  tienes_un_viaje_asignado,
  partida,
  destino,
  lo_aceptas,
  hemos_encontrado_un_conductor_para_ti,
  conductor_asignado,
  nombre,
  vehiculo,
  dominio,
  en_instantes_iniciara_el_recorrido_para_venir_a_buscarte,
  notificacion_de_pickup,
  pasajero,
  ruta_de_viaje_activada,
  buscar_en,
  tiempo_de_llegada_estimado,
  conductor_en_camino,
  conductor,
  te_avisaremos_cuando_se_encuentre_en_tu_ubicacion,
  en_viaje,
  viaje_finalizado,
  viaje_aceptado_correctamente,
  viaje_no_aceptado,
  intentaremos_ofrecerte_una_mejor_oferta,
  ruta_activada_correctamente,
  valoracion_enviada_correctamente,
  ayudanos_a_mejorar_nuestro_servicio_y_valora_los_siguientes_items,
  no_es_posible_finalizar_el_viaje_debido_a_que_tu_ubicación_no_es_correcta,
  viaje_finalizado_correctamente,
  no_es_posible_activar_el_tránsito_debido_a_que_tu_ubicación_no_es_correcta,
  transito_activado_correctamente,
  enviar_valoracion,
  ver_recorrido_en_google_maps,
  ver_recorrido,
  levantar_pasajero,
  finalizar_viaje,
  activar_ruta_de_viaje,
  sin_conexion_a_gps,
  para_continuar_debes_activar_el_gps,
  viaje_aun_no_abonado,
  avisar_a_pasajero,
  avisar_al_pasajero_que_debe_agregar_un_metodo_de_pago_valido,
  el_conductor_esta_esperandote,
  pagar_viaje,
  viaje_abonado,
  buscando_conductor,
  pendiente_de_abonar,
} from "../../utils/traductor";
// import CreditCardIcon from "@mui/icons-material/CreditCard";
import animacionNoHayGps from "../../imagenes/AnimacionesVarias/NoHayGps1.json";
import { Segment } from "semantic-ui-react";
import beepError from "../../sonidos/beepError.mp3";
import {
  getToken,
  getTokenNotificacion,
  getrole,
  setPoolingActivado,
  setViajeId,
} from "../../utils/variablesLocales";
import Backdrop from "@mui/material/Backdrop";
import CircularProgress from "@mui/material/CircularProgress";
import animacion from "../../imagenes/AnimacionesVarias/LoadingMap.json";
import Snackbar from "@mui/material/Snackbar";
import { Alert } from "@mui/material";
import { CheckCircleOutline } from "@mui/icons-material";
import ErrorOutlineIcon from "@mui/icons-material/ErrorOutline";
import WarningAmberIcon from "@mui/icons-material/WarningAmber";

const apiusuario = new apiUsuario();
const apimobbex = new apiMobbex();
const apisubastador = new apiSubastador();
const apiviaje = new apiViaje();

LeafletMarker.prototype.options.icon = icon({
  iconRetinaUrl,
  iconUrl,
  shadowUrl,
  iconSize: [25, 41],
  iconAnchor: [12, 41],
  popupAnchor: [1, -34],
  tooltipAnchor: [16, -28],
  shadowSize: [41, 41],
});

export function EstadoViajeEnInicio({
  EstadoId,
  Perfil,
  ViajeId,
  Partida,
  Destino,
  VerEnGoogleMaps,
  ChoferId,
  Pasajero,
  Kms,
  Min,
  Precio,
  PartidaLatitud,
  PartidaLongitud,
  Conductor,
  Marca,
  Modelo,
  Color,
  Dominio,
  PartidaLocalidad,
  PartidaProvincia,
  VerEnGoogleMapsRutaBusquedaPasajero,
  MinLlegadaABuscarPasajero0,
  DestinoLatitud,
  DestinoLongitud,
  Saldo,
  BotonPago,
  DatosOperacion,
}) {
  const navigate = useNavigate();

  const [Lat, setLat] = useState("");
  const [Lon, setLon] = useState("");
  const [IPPublica, setIPPublica] = useState("");
  const [UrlApi, setUrlApi] = useState("");
  const [LatIP, setLatIP] = useState("");
  const [LonIP, setLonIP] = useState("");
  const [GpsActivado, setGpsActivado] = useState(true);
  const [LatGps, setLatGps] = useState("");
  const [LonGps, setLonGps] = useState("");
  const [GeoLocalizacionCalculado, setGeoLocalizacionCalculado] = useState(0);

  // const [EstaConectado, setEstaConectado] = useState(false);

  const [Rating_LocalPoint, setRating_LocalPoint] = useState(0);
  const [Rating_Conductor, setRating_Conductor] = useState(0);
  const [Rating_Vehiculo, setRating_Vehiculo] = useState(0);

  const [open, setOpen] = React.useState(false);
  const handleClose = () => {
    setOpen(false);
  };
  const handleOpen = () => {
    setOpen(true);
  };

  let severity = "";
  let Etapa = "";
  let PermiteCancelarViaje = false;
  let Titulo = "";
  let TextoArriba = "";
  let TextoArriba1 = "";
  let TextoArriba2 = "";
  let TextoAbajo = "";
  let TextoAbajo1 = "";
  let TextoAbajo2 = "";
  let Animacion = null;
  let AnimacionAltura = 100;
  let EspacioDebajoDeAnimacion = false;
  let PreguntaSiNoActivada = false;
  let MostrarKmsMinPrecio = false;
  let MuestraMapa = false;
  let MostrarMinLlegadaABuscarPasajero = false;
  let MostrarBotonActivarRutaDeViaje = false;
  let MostrarBotonVerRecorridoEnGoogleMaps = false;
  let MostrarBotonLevantarPasajero = false;
  let MostrarBotonFinalizarViaje = false;
  let VerValorar = false;

  const CancelarViajePregunta = async (ViajeId, ChoferId, navigate) => {
    Swal.fire({
      title: vas_a_cancelar_el_viaje_seleccionado,
      text: el_viaje_no_podra_recuperarse_posterior_a_esta_accion,
      // type: "warning",
      showCancelButton: true,
      confirmButtonText: si,
      confirmButtonColor: estiloColores.Azul,
      cancelButtonText: cancelar,
      cancelButtonColor: estiloColores.Gris,
    }).then((result) => {
      if (result.value) {
        CancelarViajePreguntaAccion(ViajeId, ChoferId, navigate);
      }
    });
  };

  const CancelarViajePreguntaAccion = async (ViajeId, ChoferId, navigate) => {
    //refrescar Home a traves de push notifications
    apiviaje.refrescarHome(ViajeId, "CANCELADO");

    //cancela viaje en coleccion viaje y en usuario
    const respuesta = await apiviaje.cancelar(ViajeId);

    //muestro snackbar
    setMensajeInformacion(viaje_cancelado_con_exito);
    setOpenInformacion(true);

    if (respuesta !== undefined) {
      if (respuesta.status === 200) {
        if (getrole() === "Pasajero") {
          //pooling
          //setPoolingActivado(true);
          setViajeId("");

          navigate(ENTORNO.URL_APLICACION + "/Pasajero/Inicio");
        }

        if (getrole() === "Conductor") {
          navigate(ENTORNO.URL_APLICACION + "/Conductor/Inicio");
        }
      }
    }
  };

  const [MinLlegadaABuscarPasajero, setMinLlegadaABuscarPasajero] = useState(0);

  // The map instance:
  const [map, setMap] = useState(null);

  const [routingMachine, setRoutingMachine] = useState(null);

  // Routing machine ref
  const RoutingMachineRef = useRef(null);

  //////////////////////////////////////////////////////////////

  useEffect(() => {
    (async () => {
      try {
        //calculo geolocalizacion
        if (GeoLocalizacionCalculado === 0) {
          //calculo ip publica
          const ipPublica = require("react-public-ip");
          const ipv4 = (await ipPublica.v4()) || "";
          setIPPublica(ipv4);

          //calculo localidad y lat lon con ip publica
          setUrlApi(ENTORNO.Ping_IPtoLatLon1.replace("ipPublica", ipv4));

          const parametros = {
            method: "GET",
            headers: {
              "Content-Type": "application/json",
            },
          };

          const respuesta = await fetch(
            ENTORNO.Ping_IPtoLatLon1.replace("ipPublica", ipv4),
            parametros
          );

          const respuestaJson = await respuesta.json();

          setLatIP(respuestaJson.loc.split(",")[0]);
          setLonIP(respuestaJson.loc.split(",")[1]);

          //calculo lat lon con GPS
          const onUbicacionConcedida = (ubicacion) => {
            setLatGps(ubicacion.coords.latitude);
            setLonGps(ubicacion.coords.longitude);

            setGpsActivado(true);
            setGeoLocalizacionCalculado(1);
          };

          const onErrorDeUbicacion = (err) => {
            setLatGps("");
            setLonGps("");

            setGpsActivado(false);

            setGeoLocalizacionCalculado(0);
          };

          const opcionesDeSolicitud = {
            enableHighAccuracy: true, // Alta precisión
            maximumAge: 0, // No queremos caché
            timeout: 5000, // Esperar solo 5 segundos
          };

          // Solicitar
          navigator.geolocation.getCurrentPosition(
            onUbicacionConcedida,
            onErrorDeUbicacion,
            opcionesDeSolicitud
          );
        }
      } catch (error) {
        console.error(error);
      }
    })();
  });

  useEffect(() => {
    (async () => {
      try {
        //calculo la direccion postal con lat y lon
        if (GeoLocalizacionCalculado === 1) {
          if (LatGps === "") {
            setLat(LatIP);
            setLon(LonIP);
          } else {
            setLat(LatGps);
            setLon(LonGps);
          }
        }
      } catch (error) {
        console.error(error);
      }
    })();
  });

  // Create the routing-machine instance:
  useEffect(() => {
    if (!map) return;

    if (map) {
      RoutingMachineRef.current = L.Routing.control({
        position: "topleft",
        lineOptions: {
          addWaypoints: false,
          draggableWaypoints: false,
          styles: [
            {
              color: "#757de8",
              weight: 4,
            },
          ],
        },
        language: "es",
        formatter: new L.Routing.Formatter({
          language: "es",
        }),
        waypoints: [
          [Lat, Lon],
          [PartidaLatitud, PartidaLongitud],
        ],
        routeWhileDragging: false,
        extendToWaypoints: false,
        missingRouteTolerance: 10,
        collapsible: true,
        show: false,
      }).on("routesfound", function (e) {
        var routes = e.routes;
        var summary = routes[0].summary;

        setMinLlegadaABuscarPasajero(
          Math.round((summary.totalTime % 3600) / 60)
        );
      });
      setRoutingMachine(RoutingMachineRef.current);
    }
  }, [map]);

  // Set waypoints when start and end points are updated:
  useEffect(() => {
    // console.log("Lat: ", Lat);
    // console.log("Lon: ", Lon);
    // console.log("PartidaLatitud: ", PartidaLatitud);
    // console.log("PartidaLongitud: ", PartidaLongitud);

    if (
      Lat !== undefined &&
      Lon !== undefined &&
      PartidaLatitud !== undefined &&
      PartidaLongitud !== undefined &&
      Lat !== "undefined" &&
      Lon !== "undefined" &&
      PartidaLatitud !== "undefined" &&
      PartidaLongitud !== "undefined" &&
      Lat !== null &&
      Lon !== null &&
      PartidaLatitud !== null &&
      PartidaLongitud !== null &&
      Lat !== "null" &&
      Lon !== "null" &&
      PartidaLatitud !== "null" &&
      PartidaLongitud !== "null" &&
      Lat !== "" &&
      Lon !== "" &&
      PartidaLatitud !== "" &&
      PartidaLongitud !== ""
    ) {
      if (routingMachine) {
        routingMachine.addTo(map);
        routingMachine.setWaypoints([
          [Lat, Lon],
          [PartidaLatitud, PartidaLongitud],
        ]);
      }
    }
  }, [routingMachine, [Lat, Lon], [PartidaLatitud, PartidaLongitud]]);

  if (EstadoId === "0" && Perfil === "Pasajero") {
    Titulo = ""; //no_tienes_viajes_pendientes;
    severity = "info";
    Etapa = "";
    PermiteCancelarViaje = false;
    TextoArriba = "";
    TextoAbajo = solicita_un_viaje_en_cualquier_momento_en_cualquier_lugar;
    Animacion = Animacion_NoTienesViajesPendientes_Pasajero;
    AnimacionAltura = 150;
    EspacioDebajoDeAnimacion = false;
    MostrarKmsMinPrecio = false;
  }

  if (EstadoId === "0" && Perfil === "Conductor") {
    Titulo = ""; //no_tienes_viajes_pendientes;
    severity = "info";
    Etapa = "";
    PermiteCancelarViaje = false;
    TextoArriba = "";
    TextoAbajo = esperando_asignacion_de_viaje;
    Animacion = Animacion_NoTienesViajesPendientes_Conductor;
    AnimacionAltura = 100;
    EspacioDebajoDeAnimacion = false;
    MostrarKmsMinPrecio = false;
  }

  //pendiente
  if (EstadoId === "1" && Perfil === "Pasajero") {
    Titulo = buscando_conductor;
    severity = "info";
    Etapa = "Subasta";
    PermiteCancelarViaje = true;
    TextoArriba = tienes_un_viaje_con_destino_a + Destino;
    TextoAbajo = estamos_buscando_un_conductor_cercano_para_ti;
    Animacion = Animacion_ViajePendiente_Pasajero;
    AnimacionAltura = 140;
    EspacioDebajoDeAnimacion = false;
    MostrarKmsMinPrecio = false;
  }

  //pendiente de aceptar viaje
  if (EstadoId === "2" && Perfil === "Conductor") {
    Titulo = tienes_un_viaje_asignado;
    severity = "info";
    Etapa = "Subasta";
    PermiteCancelarViaje = false;
    TextoArriba = partida + ": " + Partida;
    TextoArriba1 = destino + ": " + Destino;
    TextoAbajo = lo_aceptas;
    EspacioDebajoDeAnimacion = false;
    PreguntaSiNoActivada = true;
    MostrarKmsMinPrecio = true;
  }

  //conductor asignado
  if (EstadoId === "3" && Perfil === "Pasajero") {
    Titulo = conductor_asignado;
    severity = "info";
    Etapa = "Post-subasta";
    PermiteCancelarViaje = true;
    TextoArriba = nombre + ": " + Conductor;
    TextoArriba1 = vehiculo + ": " + Marca + " " + Modelo + " " + Color;
    TextoArriba2 = +dominio + ": " + Dominio;
    TextoAbajo = en_instantes_iniciara_el_recorrido_para_venir_a_buscarte;
    TextoAbajo1 = "";
    TextoAbajo2 = "";
    Animacion = Animacion_HemosEncontradoUnConductor_Pasajero;
    AnimacionAltura = 140;
    EspacioDebajoDeAnimacion = false;
    PreguntaSiNoActivada = false;
    MostrarKmsMinPrecio = false;
  }

  //conductor asignado. notificacion de pickup
  if (EstadoId === "3" && Perfil === "Conductor") {
    Titulo = notificacion_de_pickup;
    severity = "info";
    Etapa = "Post-subasta";
    PermiteCancelarViaje = true;
    TextoArriba = pasajero + ": " + Pasajero;
    TextoArriba1 = "";
    TextoArriba2 = "";
    TextoAbajo = "";
    TextoAbajo1 = "";
    TextoAbajo2 = "";
    EspacioDebajoDeAnimacion = false;
    PreguntaSiNoActivada = false;
    MostrarKmsMinPrecio = false;
    MuestraMapa = true;
    MostrarMinLlegadaABuscarPasajero = true;
    MostrarBotonActivarRutaDeViaje = true;
  }

  //ruta de viaje activada
  if (EstadoId === "4" && Perfil === "Conductor") {
    Titulo = ruta_de_viaje_activada;
    severity = "info";
    Etapa = "Pre-tránsito";
    PermiteCancelarViaje = true;
    TextoArriba = pasajero + ": " + Pasajero;
    TextoArriba1 = buscar_en + ": " + Partida;
    TextoArriba2 =
      tiempo_de_llegada_estimado + ": " + MinLlegadaABuscarPasajero0 + " min";
    TextoAbajo = "";
    TextoAbajo1 = "";
    TextoAbajo2 = "";
    Animacion = Animacion_EnCamino_Conductor;
    AnimacionAltura = 100;
    EspacioDebajoDeAnimacion = false;
    PreguntaSiNoActivada = false;
    MostrarKmsMinPrecio = false;
    MostrarBotonVerRecorridoEnGoogleMaps = true;
    MostrarBotonLevantarPasajero = true;
  }

  //conductor en camino
  if (EstadoId === "4" && Perfil === "Pasajero") {
    Titulo = conductor_en_camino;
    severity = "info";
    Etapa = "Pre-tránsito";
    PermiteCancelarViaje = true;
    TextoArriba = conductor + ": " + Conductor;
    TextoArriba1 = vehiculo + ": " + Marca + " " + Modelo + " " + Color;
    TextoArriba2 = dominio + ": " + Dominio;
    TextoAbajo =
      tiempo_de_llegada_estimado + ": " + MinLlegadaABuscarPasajero0 + " min";
    TextoAbajo1 = te_avisaremos_cuando_se_encuentre_en_tu_ubicacion;
    TextoAbajo2 = "";
    Animacion = Animacion_EsperandoVehiculo_Conductor;
    AnimacionAltura = 140;
    EspacioDebajoDeAnimacion = false;
    PreguntaSiNoActivada = false;
    MostrarKmsMinPrecio = false;
  }

  //transito activado
  if (EstadoId === "5" && Perfil === "Conductor") {
    Titulo = en_viaje;
    severity = "info";
    Etapa = "Tránsito";
    PermiteCancelarViaje = true;
    TextoArriba = pasajero + ": " + Pasajero;
    TextoArriba1 = destino + ": " + Destino;
    TextoArriba2 = tiempo_de_llegada_estimado + ": " + Min + " min";
    TextoAbajo = "";
    TextoAbajo1 = "";
    TextoAbajo2 = "";
    Animacion = Animacion_EnCurso_Conductor;
    AnimacionAltura = 140;
    EspacioDebajoDeAnimacion = false;
    PreguntaSiNoActivada = false;
    MostrarKmsMinPrecio = false;
    MostrarBotonFinalizarViaje = true;
  }

  //transito activado
  if (EstadoId === "5" && Perfil === "Pasajero") {
    Titulo = en_viaje;
    severity = "info";
    Etapa = "Tránsito";
    PermiteCancelarViaje = true;
    TextoArriba = conductor + ": " + Conductor;
    TextoArriba1 = destino + ": " + Destino;
    TextoArriba2 = tiempo_de_llegada_estimado + ": " + Min + " min";
    TextoAbajo = "";
    TextoAbajo1 = "";
    TextoAbajo2 = "";
    Animacion = Animacion_EnCurso_Pasajero;
    AnimacionAltura = 140;
    EspacioDebajoDeAnimacion = false;
    PreguntaSiNoActivada = false;
    MostrarKmsMinPrecio = false;
  }

  //viaje finalizado
  if (EstadoId === "6" && Perfil === "Pasajero") {
    Titulo = viaje_finalizado;
    severity = "info";
    Etapa = "Post-tránsito";
    PermiteCancelarViaje = false;
    TextoArriba =
      ayudanos_a_mejorar_nuestro_servicio_y_valora_los_siguientes_items;
    TextoArriba1 = "";
    TextoArriba2 = "";
    TextoAbajo = "";
    TextoAbajo1 = "";
    TextoAbajo2 = "";
    Animacion = "";
    AnimacionAltura = 10;
    EspacioDebajoDeAnimacion = false;
    PreguntaSiNoActivada = false;
    MostrarKmsMinPrecio = false;
    VerValorar = true;
  }

  const FinalizarViaje = async () => {
    //muestro back-drop
    setOpen(true);

    if (ENTORNO.VALIDAR_UBICACION === "1") {
      //calcular distancia en metros desde donde esta el auto hasta el punto destino
      const lat1 = Lat;
      const lon1 = Lon;

      const lat2 = DestinoLatitud;
      const lon2 = DestinoLongitud;

      let rad = function (x) {
        return (x * Math.PI) / 180;
      };
      var R = 6378.137; //Radio de la tierra en km
      var dLat = rad(lat2 - lat1);
      var dLong = rad(lon2 - lon1);
      var a =
        Math.sin(dLat / 2) * Math.sin(dLat / 2) +
        Math.cos(rad(lat1)) *
          Math.cos(rad(lat2)) *
          Math.sin(dLong / 2) *
          Math.sin(dLong / 2);
      var c = 2 * Math.atan2(Math.sqrt(a), Math.sqrt(1 - a));

      //aquí obtienes la distancia en metros por la conversion 1Km =1000m
      var d = R * c * 1000;

      if (d > 50) {
        //muestro snackbar
        setMensajeError(
          no_es_posible_finalizar_el_viaje_debido_a_que_tu_ubicación_no_es_correcta
        );
        setOpenError(true);
      } else {
        //finalizar viaje
        await apisubastador.finalizarViaje(ViajeId, ChoferId);

        //muestro snackbar
        setMensajeInformacion(viaje_finalizado_correctamente);
        setOpenInformacion(true);
      }
    } else {
      //finalizar viaje
      await apisubastador.finalizarViaje(ViajeId, ChoferId);

      //muestro snackbar
      setMensajeInformacion(viaje_finalizado_correctamente);
      setOpenInformacion(true);
    }

    //refrescar Home a traves de push notifications
    apiviaje.refrescarHome(ViajeId, "FINALIZADO");

    //oculto back-drop
    setOpen(false);

    navigate(ENTORNO.URL_APLICACION + "/Conductor/Inicio");
  };

  const LevantarPasajero = async () => {
    //muestro back-drop
    setOpen(true);

    if (ENTORNO.VALIDAR_UBICACION === "1") {
      //calcular distancia en metros desde donde esta el auto hasta el punto destino
      const lat1 = Lat;
      const lon1 = Lon;

      const lat2 = PartidaLatitud;
      const lon2 = PartidaLongitud;

      let rad = function (x) {
        return (x * Math.PI) / 180;
      };
      var R = 6378.137; //Radio de la tierra en km
      var dLat = rad(lat2 - lat1);
      var dLong = rad(lon2 - lon1);
      var a =
        Math.sin(dLat / 2) * Math.sin(dLat / 2) +
        Math.cos(rad(lat1)) *
          Math.cos(rad(lat2)) *
          Math.sin(dLong / 2) *
          Math.sin(dLong / 2);
      var c = 2 * Math.atan2(Math.sqrt(a), Math.sqrt(1 - a));

      //aquí obtienes la distancia en metros por la conversion 1Km =1000m
      var d = R * c * 1000;

      if (d > 50) {
        //muestro snackbar
        setMensajeError(
          no_es_posible_activar_el_tránsito_debido_a_que_tu_ubicación_no_es_correcta
        );
        setOpenError(true);
      } else {
        //activar transito
        await apisubastador.activarTransito(ViajeId, ChoferId);

        //muestro snackbar
        setMensajeInformacion(transito_activado_correctamente);
        setOpenInformacion(true);
      }
    } else {
      //activar transito
      await apisubastador.activarTransito(ViajeId, ChoferId);

      //muestro snackbar
      setMensajeInformacion(transito_activado_correctamente);
      setOpenInformacion(true);
    }

    //refrescar Home a traves de push notifications
    apiviaje.refrescarHome(ViajeId, "TRANSITO ACTIVADO");

    //oculto back-drop
    setOpen(false);

    navigate(ENTORNO.URL_APLICACION + "/Conductor/Inicio");
  };

  const AvisarAPasajero = async () => {
    if (ENTORNO.VALIDAR_UBICACION === "1") {
      //calcular distancia en metros desde donde esta el auto hasta el punto destino
      const lat1 = Lat;
      const lon1 = Lon;

      const lat2 = PartidaLatitud;
      const lon2 = PartidaLongitud;

      let rad = function (x) {
        return (x * Math.PI) / 180;
      };
      var R = 6378.137; //Radio de la tierra en km
      var dLat = rad(lat2 - lat1);
      var dLong = rad(lon2 - lon1);
      var a =
        Math.sin(dLat / 2) * Math.sin(dLat / 2) +
        Math.cos(rad(lat1)) *
          Math.cos(rad(lat2)) *
          Math.sin(dLong / 2) *
          Math.sin(dLong / 2);
      var c = 2 * Math.atan2(Math.sqrt(a), Math.sqrt(1 - a));

      //aquí obtienes la distancia en metros por la conversion 1Km =1000m
      var d = R * c * 1000;

      if (d > 50) {
        //muestro snackbar
        setMensajeError(
          no_es_posible_activar_el_tránsito_debido_a_que_tu_ubicación_no_es_correcta
        );
        setOpenError(true);
      } else {
        //refrescar Home a traves de push notifications
        apiviaje.refrescarHome(ViajeId, el_conductor_esta_esperandote);
      }
    } else {
      //refrescar Home a traves de push notifications
      apiviaje.refrescarHome(ViajeId, el_conductor_esta_esperandote);
    }
  };

  const AceptarViaje = async () => {
    //muestro back-drop
    setOpen(true);

    await apisubastador.aceptarViaje(
      ViajeId,
      ChoferId,
      Pasajero,
      Partida,
      Destino,
      Min,
      Kms,
      Precio,
      Precio,
      VerEnGoogleMaps,
      PartidaLatitud,
      PartidaLongitud,
      PartidaLocalidad,
      PartidaProvincia,
      DestinoLatitud,
      DestinoLongitud,
      getTokenNotificacion()
    );

    //muestro snackbar
    setMensajeInformacion(viaje_aceptado_correctamente);
    setOpenInformacion(true);

    //refrescar Home a traves de push notifications
    apiviaje.refrescarHome(ViajeId, "CONDUCTOR ASIGNADO");

    //oculto back-drop
    setOpen(false);

    navigate(ENTORNO.URL_APLICACION + "/Conductor/Inicio");
  };

  const NoAceptarViaje = async () => {
    //muestro back-drop
    setOpen(true);

    await apisubastador.noaceptarviaje(ViajeId, ChoferId);

    //muestro snackbar
    setMensajeAlerta(viaje_no_aceptado);
    setOpenAlerta(true);

    //oculto back-drop
    setOpen(false);

    //refrescar Home a traves de push notifications
    const TokenNotificacion = getToken();

    apiviaje.refrescarHomePorToken(
      TokenNotificacion,
      viaje_no_aceptado,
      "Conductor"
    );

    navigate(ENTORNO.URL_APLICACION + "/Conductor/Inicio");
  };

  // const Actualizar = async () => {
  //   if (getrole() === "Pasajero") {
  //     navigate(ENTORNO.URL_APLICACION + "/Pasajero/Inicio");
  //   } else {
  //     navigate(ENTORNO.URL_APLICACION + "/Conductor/Inicio");

  //     navigate(ENTORNO.URL_APLICACION + "/Conductor/Inicio", {
  //       Refrescar: true,
  //     });
  //   }
  // };

  const ActivarRutaDeViaje = async () => {
    //muestro back-drop
    setOpen(true);

    const UbicacionVehiculoLatitud = Lat;
    const UbicacionVehiculoLongitud = Lon;

    const VerEnGoogleMapsRutaBusquedaPasajero =
      "https://www.google.com.ar/maps/dir/" +
      UbicacionVehiculoLatitud +
      "," +
      UbicacionVehiculoLongitud +
      "/" +
      Partida.replace("  ", " ")
        .replace(" ", "+")
        .replace("á", "a")
        .replace("é", "e")
        .replace("í", "i")
        .replace("ó", "o")
        .replace("ú", "u")
        .replace("ñ", "n") +
      "," +
      PartidaLocalidad.replace("  ", " ")
        .replace(" ", "+")
        .replace("á", "a")
        .replace("é", "e")
        .replace("í", "i")
        .replace("ó", "o")
        .replace("ú", "u")
        .replace("ñ", "n") +
      "," +
      PartidaProvincia.replace("  ", " ")
        .replace(" ", "+")
        .replace("á", "a")
        .replace("é", "e")
        .replace("í", "i")
        .replace("ó", "o")
        .replace("ú", "u")
        .replace("ñ", "n");

    await apisubastador.activarRutaDeViaje(
      ViajeId,
      ChoferId,
      UbicacionVehiculoLatitud,
      UbicacionVehiculoLongitud,
      MinLlegadaABuscarPasajero,
      VerEnGoogleMapsRutaBusquedaPasajero
    );

    //muestro snackbar
    setMensajeInformacion(ruta_activada_correctamente);
    setOpenInformacion(true);

    //refrescar Home a traves de push notifications
    apiviaje.refrescarHome(ViajeId, "RUTA DE VIAJE ACTIVADA");

    //oculto back-drop
    setOpen(false);

    navigate(ENTORNO.URL_APLICACION + "/Conductor/Inicio");
  };

  //valorar viaje
  const EnviarValoracion = async () => {
    //muestro back-drop
    setOpen(true);

    const respuesta = await apiviaje.valorar(
      ViajeId,
      Rating_LocalPoint,
      Rating_Conductor,
      Rating_Vehiculo,
      ChoferId
    );

    if (respuesta.status === 200) {
      //muestro snackbar
      setMensajeInformacion(valoracion_enviada_correctamente);
      setOpenInformacion(true);

      //refrescar Home a traves de push notifications
      apiviaje.refrescarHome(ViajeId, "VALORADO");

      //oculto back-drop
      setOpen(false);

      //pooling
      //setPoolingActivado(true);
      setViajeId("");

      navigate(ENTORNO.URL_APLICACION + "/Pasajero/Inicio");
    }
  };

  const handleRating_localpoint = (e, { rating }) => {
    e.preventDefault();
    setRating_LocalPoint(rating);
  };

  const handleRating_conductor = (e, { rating }) => {
    e.preventDefault();
    setRating_Conductor(rating);
  };

  const handleRating_vehiculo = (e, { rating }) => {
    e.preventDefault();
    setRating_Vehiculo(rating);
  };

  ///////////////////////////////////
  //notificacion snackbar informacion
  const [MensajeInformacion, setMensajeInformacion] = useState("");
  const [openInformacion, setOpenInformacion] = React.useState(false);

  // const handleCloseInformacion = (
  //   event: React.SyntheticEvent | Event,
  //   reason?: string
  // ) => {
  //   if (reason === "clickaway") {
  //     return;
  //   }

  //   setOpenInformacion(false);
  // };

  const handleCloseInformacion = (event, reason) => {
    if (reason === "clickaway") {
      return;
    }

    setOpenInformacion(false);
  };
  ///////////////////////////////////

  //notificacion snackbar error
  const [MensajeError, setMensajeError] = useState("");
  const [openError, setOpenError] = React.useState(false);

  // const handleCloseError = (
  //   event: React.SyntheticEvent | Event,
  //   reason?: string
  // ) => {
  //   if (reason === "clickaway") {
  //     return;
  //   }

  //   setOpenError(false);
  // };

  const handleCloseError = (event, reason) => {
    if (reason === "clickaway") {
      return;
    }

    setOpenError(false);
  };

  ///////////////////////////////////

  //notificacion snackbar alerta
  const [MensajeAlerta, setMensajeAlerta] = useState("");
  const [openAlerta, setOpenAlerta] = React.useState(false);

  // const handleCloseAlerta = (
  //   event: React.SyntheticEvent | Event,
  //   reason?: string
  // ) => {
  //   if (reason === "clickaway") {
  //     return;
  //   }

  //   setOpenAlerta(false);
  // };

  const handleCloseAlerta = (event, reason) => {
    if (reason === "clickaway") {
      return;
    }

    setOpenAlerta(false);
  };

  ///////////////////////////////////

  return (
    <div>
      <Card style={{ boxShadow: "none", borderRadius: "10px" }}>
        {EstadoId === "0" ? (
          <div></div>
        ) : (
          <Alert
            severity={severity}
            action={
              EstadoId === "0" ? (
                <div></div>
              ) : (
                <div>
                  <IconButton
                    size="small"
                    target="_blank"
                    rel="noopener noreferrer"
                    href={VerEnGoogleMaps}
                  >
                    <IconoVerEnGoogleMaps />
                  </IconButton>

                  {PermiteCancelarViaje === true ? (
                    <IconButton
                      size="small"
                      onClick={() => {
                        CancelarViajePregunta(ViajeId, ChoferId, navigate);
                      }}
                    >
                      <DeleteIcon />
                    </IconButton>
                  ) : (
                    <div></div>
                  )}

                  {/* <IconButton
                  size="small"
                  onClick={() => {
                    Actualizar();
                  }}
                >
                  <ActualizarIcon />
                </IconButton> */}
                </div>
              )
            }
          >
            {Titulo}
          </Alert>
        )}

        {MuestraMapa === true && LatGps !== "" && LonGps !== "" ? (
          <div>
            <MapContainer
              id="Mapa"
              name="Mapa"
              className="Mapa"
              doubleClickZoom={false}
              style={{
                height: "20vh",
                zIndex: "0",
                marginTop: "0px",
                marginLeft: "-14px",
                marginRight: "-14px",
                marginBottom: "-14px",
              }}
              zoom={10}
              scrollwheelzoom={false}
              whenCreated={(map) => setMap(map)}
            >
              <TileLayer
                attribution='&amp;copy <a href="https://www.openstreetmap.org/copyright">OpenStreetMap</a> contributors'
                url="https://{s}.tile.openstreetmap.org/{z}/{x}/{y}.png"
              />
            </MapContainer>
            <br></br>
          </div>
        ) : (
          <div></div>
        )}
        {MuestraMapa === true && LatGps === "" && LonGps === "" ? (
          <div style={{ textAlign: "center" }}>
            <Segment style={{ margin: "10px" }}>
              <Player
                src={animacionNoHayGps}
                className="player"
                loop
                autoplay
                style={{ height: 100 }}
              />
              {sin_conexion_a_gps}
              <br></br>
              {para_continuar_debes_activar_el_gps}
            </Segment>
          </div>
        ) : (
          <div></div>
        )}
        <CardContent>
          <Typography
            variant="body"
            color="text.secondary"
            style={{ textAlign: "center" }}
          >
            {TextoArriba !== "" ? <div>{TextoArriba}</div> : ""}
          </Typography>
          <Typography
            variant="body"
            color="text.secondary"
            style={{ textAlign: "center" }}
          >
            {TextoArriba1 !== "" ? <div>{TextoArriba1}</div> : ""}
          </Typography>
          <Typography
            variant="body"
            color="text.secondary"
            style={{ textAlign: "center" }}
          >
            {TextoArriba2 !== "" ? <div>{TextoArriba2}</div> : ""}
          </Typography>
          {VerValorar === true ? (
            <div>
              <br></br>
              <table style={{ width: "100%" }}>
                <tbody>
                  <tr>
                    <td>Local Point</td>
                    <td>
                      <Rating
                        icon="star"
                        defaultRating={0}
                        maxRating={5}
                        size="huge"
                        onRate={handleRating_localpoint}
                      />
                    </td>
                  </tr>
                  <tr>
                    <td>{conductor}</td>
                    <td>
                      <Rating
                        icon="star"
                        defaultRating={0}
                        maxRating={5}
                        size="huge"
                        onRate={handleRating_conductor}
                      />
                    </td>
                  </tr>
                  <tr>
                    <td>{vehiculo}</td>
                    <td>
                      <Rating
                        icon="star"
                        defaultRating={0}
                        maxRating={5}
                        size="huge"
                        onRate={handleRating_vehiculo}
                      />
                    </td>
                  </tr>
                </tbody>
              </table>
              <br></br>
              <button
                className="ui fluid button"
                style={{ borderRadius: "10px" }}
                onClick={(e) => EnviarValoracion(e)}
              >
                {enviar_valoracion}
              </button>
            </div>
          ) : (
            <div></div>
          )}
          {Animacion === null ? (
            <div></div>
          ) : (
            <div>
              <Player
                src={Animacion}
                className="player"
                loop
                autoplay
                style={{ height: AnimacionAltura }}
              />
              {EspacioDebajoDeAnimacion === true ? (
                <div>
                  <br></br>
                  <br></br>
                  <br></br>
                  <br></br>
                </div>
              ) : (
                <div></div>
              )}
            </div>
          )}
          {MostrarKmsMinPrecio === true ? (
            <div style={{ textAlign: "center" }}>
              <br></br>
              <Label
                style={{
                  backgroundColor: "transparent",
                  color: "#153B5E",
                  borderColor: "#153B5E",
                }}
              >
                <Icon name="map outline" />
                {Kms} Kms
              </Label>
              <Label
                style={{
                  backgroundColor: "transparent",
                  color: "#153B5E",
                  borderColor: "#153B5E",
                }}
              >
                <Icon name="clock outline" />
                {Min} Min
              </Label>
              <Label
                style={{
                  backgroundColor: "transparent",
                  color: "#153B5E",
                  borderColor: "#153B5E",
                }}
              >
                <Icon name="dollar sign" />
                {Precio}
              </Label>
            </div>
          ) : (
            <div></div>
          )}
          <Typography
            variant="body"
            color="text.secondary"
            style={{ textAlign: "center" }}
          >
            {TextoAbajo !== "" ? <div>{TextoAbajo}</div> : ""}
          </Typography>
          <Typography
            variant="body"
            color="text.secondary"
            style={{ textAlign: "center" }}
          >
            {TextoAbajo1 !== "" ? <div>{TextoAbajo1}</div> : ""}
          </Typography>
          <Typography
            variant="body"
            color="text.secondary"
            style={{ textAlign: "center" }}
          >
            {TextoAbajo2 !== "" ? <div>{TextoAbajo2}</div> : ""}
          </Typography>
          {MostrarBotonVerRecorridoEnGoogleMaps === true ? (
            <div style={{ textAlign: "center" }}>
              <Button
                variant="outlined"
                style={{ borderRadius: "10px" }}
                startIcon={<IconoVerEnGoogleMaps />}
                target="_blank"
                rel="noopener noreferrer"
                href={VerEnGoogleMapsRutaBusquedaPasajero}
              >
                {ver_recorrido}
              </Button>
            </div>
          ) : (
            <div></div>
          )}
          {MostrarBotonLevantarPasajero === true ? (
            <div style={{ textAlign: "center" }}>
              <br></br>
              <Button
                style={{ borderRadius: "10px" }}
                endIcon={<IconoAvisarAPasajero />}
                onClick={(e) => AvisarAPasajero(e)}
              >
                {avisar_a_pasajero}
              </Button>
              <div>
                <small>({el_conductor_esta_esperandote})</small>
              </div>
            </div>
          ) : (
            <div></div>
          )}

          {MostrarBotonLevantarPasajero === true && Saldo === 0 ? (
            <div style={{ textAlign: "center" }}>
              <br></br>
              <br></br>
              <Button
                style={{ borderRadius: "10px" }}
                variant="contained"
                endIcon={<IconoLevantarPasajero />}
                onClick={(e) => LevantarPasajero(e)}
              >
                {levantar_pasajero}
              </Button>
            </div>
          ) : (
            <div></div>
          )}
          {MostrarBotonFinalizarViaje === true ? (
            <div style={{ textAlign: "center" }}>
              <br></br>
              <Button
                style={{ borderRadius: "10px" }}
                variant="contained"
                endIcon={<IconoFinalizarViaje />}
                onClick={(e) => FinalizarViaje(e)}
              >
                {finalizar_viaje}
              </Button>
            </div>
          ) : (
            <div></div>
          )}
          {PreguntaSiNoActivada === true ? (
            <div style={{ textAlign: "Center" }}>
              <br></br>
              <Button
                style={estiloBotones.Aceptar}
                size="small"
                onClick={(e) => AceptarViaje(e)}
              >
                {si}
              </Button>
              {/* &nbsp;
              <Button
                style={estiloBotones.Cancelar}
                size="small"
                onClick={(e) => NoAceptarViaje(e)}
              >
                {no}
              </Button> */}
            </div>
          ) : (
            <div></div>
          )}
          {MostrarMinLlegadaABuscarPasajero === true ? (
            <div style={{ textAlign: "center" }}>
              <Label
                style={{
                  backgroundColor: "transparent",
                  color: "#153B5E",
                  borderColor: "#153B5E",
                }}
              >
                <Icon name="clock outline" />
                {tiempo_de_llegada_estimado}: {MinLlegadaABuscarPasajero} Min
              </Label>
            </div>
          ) : (
            <div></div>
          )}
          {MostrarBotonActivarRutaDeViaje === true &&
          GpsActivado === true &&
          LatGps !== "" &&
          LonGps !== "" ? (
            <div style={{ textAlign: "Center" }}>
              <br></br>
              <Button
                style={estiloBotones.Aceptar}
                size="small"
                onClick={(e) => ActivarRutaDeViaje(e)}
              >
                &nbsp; &nbsp; {activar_ruta_de_viaje}&nbsp; &nbsp;
              </Button>
            </div>
          ) : (
            <div></div>
          )}
          {getrole() === "Pasajero" &&
          EstadoId > 1 &&
          EstadoId < 6 &&
          Saldo > 0 ? (
            <div>
              <br></br>
              <Alert
                style={{ borderRadius: "10px" }}
                icon={<AddCardIcon fontSize="inherit" />}
                severity="warning"
                onClick={() => {
                  window.location.href = BotonPago;
                }}
              >
                {pagar_viaje}. Saldo: ${Saldo} pesos
              </Alert>
            </div>
          ) : (
            <div></div>
          )}
          {getrole() === "Pasajero" &&
          EstadoId > 1 &&
          EstadoId < 6 &&
          Saldo === 0 ? (
            <div>
              <br></br>
              <Alert
                style={{ borderRadius: "10px" }}
                icon={<PaymentIcon fontSize="inherit" />}
                severity="success"
                onClick={() => {
                  if (Saldo > 0) {
                    window.location.href = BotonPago;
                  }
                }}
              >
                {viaje_abonado}
                <br></br>
                <small>
                  {DatosOperacion.split(" - ")[1]} -{" "}
                  {DatosOperacion.split(" - ")[2]}
                </small>
              </Alert>
            </div>
          ) : (
            <div></div>
          )}
          {getrole() === "Conductor" &&
          Saldo === 0 &&
          EstadoId <= 4 &&
          ViajeId !== "" &&
          ViajeId !== "0" &&
          ViajeId !== null &&
          ViajeId !== "null" &&
          ViajeId !== undefined &&
          ViajeId !== "Undefined" ? (
            <div>
              <br></br>
              <Alert
                style={{ borderRadius: "10px" }}
                icon={<PaymentIcon fontSize="inherit" />}
                severity="success"
              >
                {viaje_abonado}
              </Alert>
            </div>
          ) : (
            <div></div>
          )}
          {getrole() === "Conductor" &&
          EstadoId > 2 &&
          EstadoId < 6 &&
          Saldo > 0 &&
          ViajeId !== "" &&
          ViajeId !== "0" &&
          ViajeId !== null &&
          ViajeId !== "null" &&
          ViajeId !== undefined &&
          ViajeId !== "Undefined" ? (
            <div>
              <br></br>
              <Alert
                style={{ borderRadius: "10px" }}
                icon={<PaymentIcon fontSize="inherit" />}
                severity="warning"
              >
                {pendiente_de_abonar}
              </Alert>
            </div>
          ) : (
            <div></div>
          )}
        </CardContent>
      </Card>
      <div style={{ textAlign: "center", color: "gainsboro" }}>
        <small>{ViajeId}</small>
      </div>

      <Backdrop
        sx={{ color: "#fff", zIndex: (theme) => theme.zIndex.drawer + 1 }}
        open={open}
        onClick={handleClose}
      >
        <Player
          src={animacion}
          className="player"
          loop
          autoplay
          style={{ height: 110 }}
        />
      </Backdrop>

      <Snackbar
        open={openInformacion}
        onClose={handleCloseInformacion}
        autoHideDuration={3000}
        anchorOrigin={{ vertical: "top", horizontal: "center" }}
      >
        <Alert
          icon={<CheckCircleOutline fontSize="inherit" />}
          severity="success"
          variant="filled"
          sx={{ width: "100%" }}
        >
          {MensajeInformacion}
        </Alert>
      </Snackbar>

      <Snackbar
        open={openError}
        onClose={handleCloseError}
        autoHideDuration={6000}
        anchorOrigin={{ vertical: "top", horizontal: "center" }}
      >
        <Alert
          icon={<ErrorOutlineIcon fontSize="inherit" />}
          severity="error"
          variant="filled"
          sx={{ width: "100%" }}
        >
          {MensajeError}
        </Alert>
      </Snackbar>

      <Snackbar
        open={openAlerta}
        onClose={handleCloseAlerta}
        autoHideDuration={6000}
        anchorOrigin={{ vertical: "top", horizontal: "center" }}
      >
        <Alert
          icon={<WarningAmberIcon fontSize="inherit" />}
          severity="error"
          variant="filled"
          sx={{ width: "100%" }}
        >
          {MensajeAlerta}
        </Alert>
      </Snackbar>
    </div>
  );
}
